import { useTranslation } from 'react-i18next'
import { InputTextProps } from '../InputText/types'
import * as React from 'react'
import InputText from '../InputText/InputText'
import Icon from '../Icon'
import '@sass/_input-search.scss'

const InputSearch = ({
    hideLabel = true,
    required = false,
    ...props
}: InputTextProps) => {
    const { t } = useTranslation();

    return (
        <div className='input-search'>
            <InputText
                id={props.id}
                label={props.label}
                placeholder={props.placeholder || t('placeholder.search')}
                hideLabel={hideLabel}
                required={required}
                value={props.value}
                maxLength={props.maxLength || undefined}
                autoComplete={props.autoComplete || 'on'}
                onChange={props.onChange}
            />
            <Icon iconName="search" size={14} color={"#0094bf"}/>
        </div>
    )
}

export default InputSearch;